import React from 'react';
import Header from "./components/Header";
import ReactSVG from "react-svg";

const AppLoading = () => {

  return <div className="app app-content-container app--loading">
    <Header appIsLoading={true} />
    <div className="pageContainer">
      <ReactSVG src="/classpath/assets/images/loading.svg" />
    </div>
  </div>;
};

export default AppLoading;
